import Overlay from "./Overlay";

export default class OverlayManager {

    constructor() {

        this.overlays = []

        $('[data-overlay]').each((index, val) => {
            let overlay = new Overlay($(val))
            this.overlays.push(overlay)
        })

    }
}